import React, { useEffect, useState } from 'react'
import T from 'prop-types'
import { Box, Button, Link as MuiLink, Stack, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'

import InputLabel from 'components/atoms/InputLabel'

const VARIANT_LIST = 'list'
const VARIANT_DETAILS = 'details'

export default function CarReprice({
  variant = VARIANT_LIST,
  car,
  handleConfirmReprice = () => {},
  handleShowDetails,
  readOnly = false,
  ...others
}) {
  const { t } = useTranslation()

  const [localValue, setLocalValue] = useState('')

  useEffect(() => {
    setLocalValue(car.reprice || '')
  }, [car.reprice])

  const handleChange = (e) => {
    setLocalValue(e.target.value)
  }

  const handleConfirm = () => {
    handleConfirmReprice(
      car.plate,
      car.reprice !== Number(localValue) ? localValue || null : null
    )
  }

  const isDetails = variant === VARIANT_DETAILS

  return (
    <Stack
      direction={isDetails ? undefined : 'row'}
      justifyContent="space-between"
      alignItems={isDetails ? undefined : 'center'}
      mt={2}
      data-testid="car-reprice"
      {...others}
    >
      {!isDetails && (
        <div>
          <MuiLink
            color="primary"
            component={Box}
            onClick={handleShowDetails}
            variant="body2"
            sx={{ cursor: 'pointer' }}
          >
            <strong>{t('carsToBuy.details')}</strong>
          </MuiLink>
        </div>
      )}
      <Stack
        direction={isDetails ? undefined : 'row'}
        justifyContent={isDetails ? undefined : 'flex-end'}
        mt={2}
      >
        <div>
          {isDetails && (
            <InputLabel
              label={t('carsToBuy.reprice.repriceProposal')}
              inputId={`${car.plate}.reprice.input`}
              sx={{ color: 'text.primary' }}
            />
          )}
          <TextField
            id={`${car.plate}.reprice.input`}
            value={localValue || ''}
            label={
              !isDetails ? t('carsToBuy.reprice.repriceProposal') : undefined
            }
            placeholder={isDetails ? t('carsToBuy.reprice.price') : undefined}
            type="number"
            size="small"
            variant={isDetails ? 'outlined' : undefined}
            fullWidth={isDetails}
            onChange={handleChange}
          />
        </div>
        {isDetails && <Box pb={2} pr={2} />}
        <Button
          color="primary"
          variant="contained"
          disabled={(!localValue && !car.reprice) || readOnly}
          onClick={handleConfirm}
          sx={{
            marginLeft: (theme) => (isDetails ? undefined : theme.spacing(2)),
          }}
        >
          {t(
            `carsToBuy.reprice.${
              car.reprice !== Number(localValue) ? 'confirm' : 'remove'
            }`
          )}
        </Button>
      </Stack>
    </Stack>
  )
}

CarReprice.propTypes = {
  variant: T.oneOf([VARIANT_LIST, VARIANT_DETAILS]),
  car: T.object.isRequired,
  handleConfirmReprice: T.func,
  handleShowDetails: T.func,
  readOnly: T.bool,
}
